import { ApiResponse } from './../model/apiresponse';
import { UserModel } from './../model/UserModel';
import { Injectable } from '@angular/core';


import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationService } from './common/configuration.service';
import { retry   } from 'rxjs/operators';
import { AccountService } from './account.service';
import { ActiveSessions } from '../model/activeSessions';
import { environment } from 'src/environments/environment';
 

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService 
{
  private currentUserSubject: BehaviorSubject<UserModel>;
  public currentUser: Observable<UserModel>;

  private baseUrl: string;

  
  public get currentUserValue(): UserModel
   {
      
    var my_object = JSON.parse(localStorage.getItem('currentUser'));
    return my_object;

}

logout() {
  
  // remove user from local storage to log user out
  localStorage.removeItem('currentUser');
  localStorage.removeItem('ACCESS_TOKEN');
  localStorage.removeItem('activesessions')
  
 
}

Url :string;  
token : string;  
header : any;  
constructor(private http : HttpClient, private config: ConfigurationService, private accountService: AccountService) 
{   
  this.baseUrl=config.baseHttpURL;
  this.Url =this.baseUrl ;

  const headerSettings: {[name: string]: string | string[]; } = {};  
  this.header = new HttpHeaders(headerSettings);  
}  

Login(model : any){  
 
  
  //let url = `${environment.lteHttpBaseUrl}/api/auth/user/validate?username=${model.username}&password=${model.password}`;

 
  //return this.http.get<any>(url);
 

  let url =`${environment.lteHttpBaseUrl}/api/auth/user/ValidateUse` ;
  return this.http.post<any>(url,model);
   
 
}  



isLoggedIn() 
{



 
  var my_object = JSON.parse(localStorage.getItem('currentUser'));

  

  if (my_object) {

    return true;
  }
  return false;
}



 getCurrentUser() : UserModel
 {

   var my_object :UserModel = JSON.parse(localStorage.getItem('currentUser'));
  
  return  my_object;
  

 }
 


GeetActiveSession(): any
{
  let activeSessions: ActiveSessions;
  var my_object = JSON.parse(localStorage.getItem('currentUser'));


 }




 parseString(data: any) : any {
        
          
  return new UserModel(data.userID, data.userName,data.passwordHash,data.firstName, data.lastName,data.securityStamp,data.discriminator,
    data.i_Customer,data.accountID,data.i_Account, data.defaultPassword,data.token );
}
}
